import React from 'react';
import Text from 'components/Text';

interface ListItemProps {
    children: React.ReactNode;
}

const ListItem: React.FC<ListItemProps> = ({ children }) => (
    <li>
        <Text display="inline-block" my="8px">
            {children}
        </Text>
    </li>
);

export default ListItem;
